import React from "react";
import { Button as MuiButton, Divider, Typography } from "@mui/material";
import { Stack } from "@mui/system";

const Footer = () => {
  return (
    <Stack className="background-black" alignItems="center">
      <Stack direction="column" width="85%" py={3} mb={8}>
        <Stack justifyContent="center" mb={6}>
          <img
            src="/assets/logo.png"
            width="258.6px"
            height="53.6px"
            alt="logo"
          />
        </Stack>
        <Stack flexDirection="row">
          <Stack
            flexDirection="column"
            width="25%"
            alignItems="flex-start"
            spacing={2}
            mr={8}
          >
            <Typography className="font-white">
              Your Complete View To WHAT's GOING ON In the Financial Services
              Industry
            </Typography>
            <MuiButton
              variant="contained"
              color="primary"
              style={{
                fontSize: 16,
                fontWeight: 700,
                height: 45,
                width: 155,
                padding: 0,
              }}
            >
              Search Events
            </MuiButton>

            <Stack flexDirection="row">
              <i
                className="fab fa-facebook font-white"
                style={{ marginRight: "14px" }}
              />
              <i
                className="fab fa-twitter font-white"
                style={{ marginRight: "14px" }}
              />
              <i
                className="fab fa-linkedin font-white"
                style={{ marginRight: "14px" }}
              />
            </Stack>
          </Stack>
          <Divider
            style={{
              border: "1px solid rgba(255, 255, 255, 0.29)",
            }}
          />
          <Stack
            flexDirection="column"
            width="30%"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography className="font-white">Find Events</Typography>
            <Typography className="font-white">Post Your Event</Typography>
            <Typography className="font-white">Create an Event</Typography>
            <Typography className="font-white">Services</Typography>
            <Typography className="font-white">Membership</Typography>
            <Typography className="font-white">About Us</Typography>
          </Stack>
          <Divider
            style={{
              border: "1px solid rgba(255, 255, 255, 0.29)",
            }}
          />
          <Stack
            flexDirection="column"
            width="30%"
            alignItems="flex-start"
            ml={8}
            style={{ placeContent: "space-between" }}
          >
            <Typography className="font-white" fontWeight={700}>
              Contact Us
            </Typography>
            <Stack flexDirection="row">
              <i
                className="fad fa-map-marker-alt font-white"
                style={{ marginRight: 8 }}
              />
              <Typography className="font-white">
                EventView360 8924 E. Pinnacle Peak Rd. STE G-5 #619 Scottsdale,
                AZ 85255-3649
              </Typography>
            </Stack>
            <Stack flexDirection="row">
              <i
                className="fas fa-phone-alt font-white"
                style={{ marginRight: 8 }}
              />
              <Typography className="font-white">
                Phone: (949) 302-6472
              </Typography>
            </Stack>
            <Stack flexDirection="row">
              <i
                className="fas fa-envelope font-white "
                style={{ marginRight: 8 }}
              />
              <Typography className="font-white">
                info@eventview360.com
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};
export default Footer;
